import { getApiBaseUrl } from "../config/appSettings";
import { emitSaveFeedback } from "./saveFeedback";

export async function apiGet(path, options = {}) {
  const apiBaseUrl = getApiBaseUrl();
  const url = `${apiBaseUrl}${path}`;
  try {
    const res = await fetch(url, {
      headers: {
        Accept: "application/json",
        ...(options.headers ?? {})
      }
    });
    if (!res.ok) {
      const text = await res.text();
      return { ok: false, data: null, error: text || res.statusText };
    }
    const data = await res.json();
    return { ok: true, data };
  } catch (err) {
    const msg = err instanceof Error ? err.message : "Network error";
    return { ok: false, data: null, error: msg };
  }
}

export async function apiPost(path, body, options = {}) {
  const apiBaseUrl = getApiBaseUrl();
  const url = `${apiBaseUrl}${path}`;
  const feedbackEnabled = options.feedback !== false;
  if (feedbackEnabled) {
    emitSaveFeedback({ phase: "start", path });
  }
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...(options.headers ?? {})
      },
      body: JSON.stringify(body)
    });
    if (!res.ok) {
      const text = await res.text();
      if (feedbackEnabled) {
        emitSaveFeedback({ phase: "error", path, message: text || res.statusText || "Save failed." });
      }
      return { ok: false, data: null, error: text || res.statusText };
    }
    const data = await res.json();
    if (feedbackEnabled) {
      emitSaveFeedback({ phase: "success", path });
    }
    return { ok: true, data };
  } catch (err) {
    const msg = err instanceof Error ? err.message : "Network error";
    if (feedbackEnabled) {
      emitSaveFeedback({ phase: "error", path, message: msg });
    }
    return { ok: false, data: null, error: msg };
  }
}

export async function apiDelete(path) {
  const apiBaseUrl = getApiBaseUrl();
  const url = `${apiBaseUrl}${path}`;
  try {
    const res = await fetch(url, {
      method: "DELETE"
    });
    if (!res.ok) {
      const text = await res.text();
      return { ok: false, data: null, error: text || res.statusText };
    }
    return { ok: true, data: null };
  } catch (err) {
    const msg = err instanceof Error ? err.message : "Network error";
    return { ok: false, data: null, error: msg };
  }
}

export async function apiUploadImage(path, file) {
  const apiBaseUrl = getApiBaseUrl();
  const url = `${apiBaseUrl}${path}`;
  try {
    const formData = new FormData();
    formData.append("file", file);

    const res = await fetch(url, {
      method: "POST",
      body: formData
    });

    if (!res.ok) {
      const text = await res.text();
      return { ok: false, data: null, error: text || res.statusText };
    }

    const data = await res.json();
    return { ok: true, data };
  } catch (err) {
    const msg = err instanceof Error ? err.message : "Network error";
    return { ok: false, data: null, error: msg };
  }
}
